import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Ship } from "lucide-react";
import { BRAND } from "../lib/brand";

export default function Footer() {
  return (
    <footer className="bg-[#1E2A78] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={BRAND.logo} alt="Amplartic" className="h-12 w-12 object-contain bg-white rounded-sm p-1" />
            <div>
              <div className="font-display font-extrabold tracking-tight">AMPLARTIC</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-300">Logistics Inc.</div>
            </div>
          </div>
          <p className="text-sm text-slate-300 leading-relaxed">
            {BRAND.tagline}. Connecting Canada & USA to the English Caribbean since day one.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-[#FFD700] mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/courier" className="hover:text-white">Courier</Link></li>
            <li><Link to="/sourcing" className="hover:text-white">Sourcing</Link></li>
            <li><Link to="/pickup" className="hover:text-white">Request Pickup</Link></li>
            <li><Link to="/quote" className="hover:text-white" data-testid="footer-quote-link">Get a Quote</Link></li>
            <li><Link to="/forms" className="hover:text-white">Forms</Link></li>
            <li><Link to="/track" className="hover:text-white">Track Shipment</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-[#FFD700] mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 mt-0.5 text-[#FFD700]" />
              <a href={BRAND.phoneHref} className="hover:text-white">{BRAND.phone}</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 mt-0.5 text-[#FFD700]" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-white break-all">{BRAND.email}</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-[#FFD700] mb-4">Offices</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            {BRAND.offices.map((o) => (
              <li key={o.city} className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 text-[#FFD700]" />
                <span>{o.city}, {o.region}, {o.country}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-300">
          <div className="flex items-center gap-2">
            <Ship className="h-4 w-4 text-[#FFD700]" />
            <span>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
